export default api => ({
  uploadFile: (data, onUploadProgress) => api.post('profile/upload', data, {
    header: {
      'Content-Type': 'multipart/form-data'
    },
    onUploadProgress
  }),
  settings: () => api.get('profile/settings'),

  // dictionaries
  getBusinessFrequencies: () => api.get('profile/refs/business_frequencies'),
  getBusinessTargets: () => api.get('profile/refs/business_targets'),
  getCurrencies: () => api.get('profile/refs/currencies'),
  getPassportTypes: () => api.get('profile/refs/passport_types'),
  getCountriesBlackList: () => api.get('profile/refs/blacklist_countries'),
  downloadSignDoc: (data) => api.get(`profile/sign_doc/${data}`,{responseType: 'blob'}),
  downloadDoc: (data) => api.get(`profile/doc/${data}`,{responseType: 'blob'}),
  getEmploymentOptions: () => api.get('profile/refs/employment_types'),
  getProceedOptions: () => api.get('profile/refs/income_levels'),
  downloadSignDocs: (data) => api.get(`profile/nonresident/sign_doc/${data}`,{responseType: 'blob'}),

  // form
  resident: {
    getQrCode: {
      get: () => api.get('profile/sharing/deeplink/'),
    },
    updateQrCode: {
      get:() => api.get('profile/sharing/deeplink/new/')
    },
    sharingResult: () => api.get('profile/sharing/result/'),
    sharingData: {
      get:() => api.get('profile/sharing/step_confirm'),
      post:(data) => api.post('profile/sharing/step_confirm', data)
    },
    step0: {
      get: () => api.get('profile/step_citizenship/'),
      post: data => api.post('profile/step_citizenship/', data),
    },
    step1: {
      get: () => api.get('profile/step_name'),
      post: data => api.post('profile/step_name', data),
    },
    step2: {
      get: () => api.get('profile/step_passport'),
      post: data => api.post('profile/step_passport', data),
    },
    step3: {
      get: () => api.get('profile/step_address'),
      post: data => api.post('profile/step_address', data),
    },
    step4: {
      get: () => api.get('profile/step_accounts'),
      post: data => api.post('profile/step_accounts', data),
    },
    step5: {
      get: () => api.get('profile/step_fatca'),
      post: data => api.post('profile/step_fatca', data),
    },
    step6: {
      get: () => api.get('profile/step_targets'),
      post: data => api.post('profile/step_targets', data),
    },

    diiaSign: {
      get: () => api.get('diia_sign/'),
      post: (data) => api.post('diia_sign/', data),
    },
    getSignDocQrCode: {
      get: () => api.get('diia_sign/deeplink/'),
    },
    updateSignDocQrCode: {
      get: () => api.get('diia_sign/deeplink/new/'),
    },
    checkDiiaSignDocResult: {
      get:() => api.get('diia_sign/result/')
    }

  },
  nonresident:{
    step0: {
      get: () => api.get('profile/step_citizenship/'),
      post: data => api.post('profile/step_citizenship/', data),
    },
    step1: {
      get: () => api.get('profile/nonresident/step_name'),
      post: data => api.post('profile/nonresident/step_name', data),
    },
    step2: {
      get: () => api.get('profile/nonresident/step_passport'),
      post: data => api.post('profile/nonresident/step_passport', data),
    },
    step3: {
      get: () => api.get('profile/nonresident/step_address'),
      post: data => api.post('profile/nonresident/step_address', data),
    },
    step4: {
      get: () => api.get('profile/nonresident/step_accounts'),
      post: data => api.post('profile/nonresident/step_accounts', data),
    },
    step5: {
      get: () => api.get('profile/nonresident/step_fatca'),
      post: data => api.post('profile/nonresident/step_fatca', data),
    },
    step6: {
      get: () => api.get('profile/nonresident/step_targets'),
      post: data => api.post('profile/nonresident/step_targets', data),
    },
    signOtp: {
      get: () => api.get('profile/nonresident/sign_otp'),
      post: data => api.post('profile/nonresident/sign_otp', data)
    },
    confirmSignOtp: {
      post: data => api.post('profile/nonresident/sign_otp/confirm', data)
    },
    signedDocuments:{
      get:() => api.get('profile/nonresident/sign_otp/signed/')
    }

  }
})
